'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timingMark = timingMark;
exports.timingMeasure = timingMeasure;
exports.itemLoadStart = itemLoadStart;
exports.itemLoaded = itemLoaded;
exports.appLoaded = appLoaded;
exports.appPartiallyLoaded = appPartiallyLoaded;

var _WixSdkWrapper = require('../sdk/WixSdkWrapper');

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _biLogger = require('../utils/biLogger');

var _baseUtils = require('./baseUtils.js');

var _fedopsLogger2 = require('@wix/fedops-logger');

var fedopsLogger = _interopRequireWildcard(_fedopsLogger2);

var _windowWrapper = require('../sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function timingMark(name) {
  try {
    _windowWrapper2.default.performance && _windowWrapper2.default.performance.mark && _windowWrapper2.default.performance.mark(name);
  } catch (e) {
    console.error('Error in timingMark', e);
  }
}

function timingMeasure(measureName, startMarkName, endMarkName) {
  try {
    if (_windowWrapper2.default.performance && performance.measure) {
      if (endMarkName) {
        //performance.measure is not allowed to get undefined in ie
        performance.measure(measureName, startMarkName, endMarkName);
      } else if (startMarkName) {
        performance.measure(measureName, startMarkName);
      } else {
        performance.measure(measureName);
      }
    }
  } catch (e) {
    console.error('Error in timingMeasure', e);
  }
}

function itemLoadStart() {
  try {
    if (!_windowWrapper2.default.itemLoadStart) {
      _windowWrapper2.default.itemLoadStart = true;
      timingMark('itemLoadStart');
    }
  } catch (e) {
    //
  }
}

function itemLoaded() {
  try {
    if (_baseUtils.baseUtils.isTest() || _baseUtils.baseUtils.isOOI()) {
      return;
    }
    if (!_windowWrapper2.default.proGalleryItemLoaded) {
      timingMeasure('firstItemLoaded', 'itemLoadStart');
      _windowWrapper2.default.proGalleryItemLoaded = true;
      // appLoaded('pro-gallery-statics')
      if (_windowWrapper2.default.performance && performance.getEntriesByName) {
        var _performance$getEntri = performance.getEntriesByName('firstItemLoaded')[0],
            startTime = _performance$getEntri.startTime,
            duration = _performance$getEntri.duration;

        _biLogger.logger.trackBi(_biLogger.logger.biEvents.pro_gallery_load_uou, {
          endpoint: 'itemLoadStart',
          loading_time: Math.round(startTime)
        });
        _biLogger.logger.trackBi(_biLogger.logger.biEvents.pro_gallery_load_uou, {
          endpoint: 'firstItemLoadDuration',
          loading_time: Math.round(duration + startTime)
        });
      }
    }
  } catch (e) {
    // console.error('apploaded measure', e);
  }
}

function appLoaded(appName) {
  try {
    if (_baseUtils.baseUtils.isTest() || _baseUtils.baseUtils.isOOI()) {
      return;
    }
    if (!_windowWrapper2.default.proGalleryLoaded) {
      _windowWrapper2.default.proGalleryLoaded = true;
      console.log('Pro Gallery Loaded');
      _WixSdkWrapper2.default.Performance.applicationLoaded();
      var _fedopsLogger = fedopsLogger.create(appName, {
        networkAnalysis: _windowWrapper2.default.debugApp === 'fedops'
      });
      if (_fedopsLogger) {
        _fedopsLogger.appLoaded();
      }
    }
  } catch (e) {
    // console.log('fedopsLogger: apploaded failed ', appName, e);
  }
}

function appPartiallyLoaded() {
  try {
    if (_baseUtils.baseUtils.isTest() || _baseUtils.baseUtils.isOOI()) {
      return;
    }
    if (!_windowWrapper2.default.proGalleryPartiallyLoaded) {
      _windowWrapper2.default.proGalleryPartiallyLoaded = true;
      console.log('Pro Gallery Partially Loaded');
      _WixSdkWrapper2.default.Performance.applicationLoadingStep(1, 'Pro Gallery is Loading');
    }
  } catch (e) {
    // console.log('Wix performance: appPartiallyLoaded failed ', _appName, e);
  }
}